// extracted by mini-css-extract-plugin
module.exports = {"home-page":"HomePage_home-page__2ISts","home-page__hero":"HomePage_home-page__hero__2alSu","menu-link":"HomePage_menu-link__yTWC0","button":"HomePage_button__3ylU7"};